import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { ko } from "date-fns/locale";
import { FaCalendarAlt } from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";

const DateInput = ({
  name,
  placeholder = "연도-월-일",
  rules = {},
  className = "",
  divStyle = "",
  ...rest
}) => {
  const { control  } = useFormContext();

  const { minDate, ...restProps } = rest;
  // 만약 minDate가 전달되었으면, 문자열이면 Date 객체로 변환
  const convertedMinDate =
    minDate && typeof minDate === "string"
      ? new Date(minDate.replace(" ", "T"))
      : minDate || undefined;

  const styles = {
    container: {
      position: "relative",
      display: "inline-block"
    },
  };

  return (
    <div style={{ ...divStyle, ...styles.container }}>
      <FaCalendarAlt className="calendar-icon" />
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <DatePicker
            {...field}
            locale={ko}
            dateFormat="yyyy-MM-dd"
            placeholderText={placeholder}
            selected={field.value ? new Date(field.value.replace(" ", "T")) : null}
            onChange={(date) =>
              field.onChange(date ? format(date, "yyyy-MM-dd") : "")
            }
            className={className}
            showYearDropdown
            scrollableYearDropdown
            yearDropdownItemNumber={10}
            portalId="root-portal"
            popperClassName="date-popper"
            minDate={convertedMinDate}
            {...restProps}
          />

        )}
      />
    </div>
  );
};

export default DateInput;
